<script>
    export default {
        name: 'alert',

        props: {
            html: {
                type: String,
                required: true
            },
            color: {
                type: String,
                default: 'info'
            },
            icon: {
                type: String,
                default: 'info'
            },
            trigger: Boolean,
            position: {
                type: String,
                default: 'top'
            }
        },

        render(createElement) {
            return createElement('span', this.$slots.default)
        },

        watch: {
            trigger(newValue) {
                if (newValue) this.$q.notify({
                    color: this.color,
                    icon: this.icon,
                    message: this.html,
                    position: this.position
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Alert.vue